import { Link } from "react-router-dom";
import { footerGroups, site } from "@/config/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-700">
                <span className="font-heading text-xl font-bold leading-none">料</span>
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">{site.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              {site.intro}
            </p>
            <Link
              to="/submit"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
              进入投稿通道
            </Link>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-200 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/20 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {site.since}-2026 {site.name} · 本站内容为读者投稿与公开信息核实整理
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line" aria-hidden="true"></i>
              投稿邮箱：{site.email}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" aria-hidden="true"></i>
              {site.handlingHours}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}